import i18n from '@/i18n'
import { stateService } from '@/services/state.service'
import { mapActions } from 'vuex'
import { SnackbarStyle, EventHub } from '@/constants/constants'
import { DialogStateType } from "@/tools/dialog"
import StateTypeDialogDataTabComponent from './tabs/data/StateTypeDialogDataTabComponent.vue'
import StateTypeDialogEnterpriseTabComponent from './tabs/enterprise/StateTypeDialogEnterpriseTabComponent.vue'
import Vue from 'vue'
import { enterpriseService } from '@/services/enterprise.service'

export default {
    name: 'StateTypeDialogComponent',
    components: {
        StateTypeDialogDataTabComponent,
        StateTypeDialogEnterpriseTabComponent
    },
    props: {
        // v-model injects the object to be edited into props.value
        model: {
            type: Object,
            required: true
        },
        update: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: () => ({
        // model del formulario
        validForm: false,
        // reglas de validación
        validationRules: {
            required: (value) => !!value || `${i18n.t('required')}`,
            maxLength: (str, length) => !str || str.length <= length || `${i18n.t('error.strMaxLength', { length })}`
        },
        // tab seleccionada
        tab: null,
        // modelos de los tabs
        stateTypeDialogDataTab: {
            key: 'stateTypeDialogDataTab',
            tab: i18n.t('stateType.editDialog.tabs.data'),
            tooltip: i18n.t('stateType.editDialog.tabs.dataTooltip'),
            icon: 'mdi-form-textbox',
            content: {
                _uid: 'oLkbANttlu',
                component: 'StateTypeDialogDataTabComponent',
                headline: 'StateTypeDialogDataTabComponent'
            },
            model: {
                name: { es: null, en: null, pt: null },
                color: '#ff0000',
                comment: null,
                update: false
            },
            validForm: false
        },
        stateTypeDialogEnterpriseTab: {
            key: 'stateTypeDialogEnterpriseTab',
            tab: i18n.t('stateType.editDialog.tabs.enterprises'),
            tooltip: i18n.t('stateType.editDialog.tabs.enterprisesTooltip'),
            icon: 'mdi-office-building',
            content: {
                _uid: 'oLkbANttlv',
                component: 'StateTypeDialogEnterpriseTabComponent',
                headline: 'StateTypeDialogEnterpriseTabComponent'
            },
            model: {
                enterprisesData: [],
                enterprises: [],
                global: false,
                update: false
            },
            validForm: false
        },
        tabs: [],
        // flag para resetear validaciones en los formularios
        resetForms: false
    }),
    computed: {
        disabledButton () {
            return !this.stateTypeDialogDataTab.validForm || !this.stateTypeDialogEnterpriseTab.validForm
        }
    },
    created() {
    },
    mounted() {
        // pusheo los tabs
        this.tabs.push(this.stateTypeDialogDataTab)
        this.tabs.push(this.stateTypeDialogEnterpriseTab)
    },
    methods: {
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread',
            'pushBread'
        ]),
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            // tab de datos personales
            this.stateTypeDialogDataTab.model.name = { es: null, en: null, pt: null },
            this.stateTypeDialogDataTab.model.color = '#ff0000',
            this.stateTypeDialogDataTab.model.comment = null
            
            // tab de empresas
            this.stateTypeDialogEnterpriseTab.model.enterprises = []
            this.stateTypeDialogEnterpriseTab.model.enterprisesData = []
            this.stateTypeDialogEnterpriseTab.model.global = false

            // updates
            this.stateTypeDialogDataTab.model.update = false
            this.stateTypeDialogEnterpriseTab.model.update = false

            // para limpiar las validaciones en los formularios
            this.resetForms = true
            const that = this
            Vue.nextTick(function() {
                that.resetForms = false
            })
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.pullBread(DialogStateType)
            this.resetFields()
        },
        /**
         * Guardar
         */
        save() {
            const stateTypeDto = this.getStateTypeDto()
            if (this.update) {
                stateService.updateStateType(stateTypeDto).then(() => {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('stateType.successUpdateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                    this.resetFields()
                    this.$emit('commitStateType')
                    this.cancel()
                })
            } else {
                stateService.createStateType(stateTypeDto).then((insertedId) => {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('stateType.successCreateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                    this.resetFields()
                    this.$emit('commitStateType')
                    this.cancel()
                    this.$eventBus.$emit(EventHub.COMMIT_STATE_TYPE, insertedId)
                })
            }
        },
        /**
         * Genera el DTO para actualizar / crear un tipo de stateo
         */
        getStateTypeDto() {
            const result = {
                name: this.stateTypeDialogDataTab.model.name,
                color: this.stateTypeDialogDataTab.model.color,
                comment: this.stateTypeDialogDataTab.model.comment,
                enterprises: this.stateTypeDialogEnterpriseTab.model.enterprises,
                global: this.stateTypeDialogEnterpriseTab.model.global,
            }
            if (this.update) {
                result._id = this.model._id
            }
            return result
        }
    },
    watch: {
        model: {
            deep: true,
            immediate: true,
            handler: async function (newModel) {
                if (newModel) {
                    // tab de datos personales
                    this.stateTypeDialogDataTab.model.name = newModel.name,
                    this.stateTypeDialogDataTab.model.color = newModel.color,
                    this.stateTypeDialogDataTab.model.comment = newModel.comment
                    
                    // tab de empresas
                    this.stateTypeDialogEnterpriseTab.model.enterprises = newModel.enterprises
                    this.stateTypeDialogEnterpriseTab.model.enterprisesData = await enterpriseService.getAllForSelectorUserABM(newModel.enterprises)
                    this.stateTypeDialogEnterpriseTab.model.global = newModel.global

                    // updates
                    this.stateTypeDialogDataTab.model.update = newModel.update
                    this.stateTypeDialogEnterpriseTab.model.update = newModel.update
                }
            }
        }
    }
}
